module.exports = __webpack_public_path__ + "media/images/bg-31281bddbbb510c6db6a1f691c080ae9.png";